import { createSlice } from '@reduxjs/toolkit';
import { createScopedStore, createIndependentStore } from '@utils/react';

function makeConsentStore(initialState) {
  const slice = createSlice({
    name: `provider/consent`,
    initialState,
    reducers: {
      updateConsent(state, action) {
        state.cookies = action.payload.cookies;
      }
    }
  });
  return createIndependentStore(slice);
}
const consentStore = createScopedStore(
  makeConsentStore({
    cookies: {
      necessary: false,
      preferences: false,
      statistics: false,
      marketing: false
    }
  })
);
const useConsentSelector = consentStore.useSelector;

export { consentStore, makeConsentStore, useConsentSelector };
//# sourceMappingURL=_store.js.map
